import { useState } from "react";
import axios from "axios";
import IsLoading from "../../../isLoading";
import "./archivesAdmHub.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as Action from "../../../store/redux/admission_reducer.js";

let Applicant;

export default function ArchivesAdmHub() {
  const dispatch = useDispatch();
  const redirect = useNavigate();
  const [loading, setLoading] = useState(false);
  const [AppNo, setAppNo] = useState("");
  const [id, setId] = useState("");

  async function getClientStatus() {
    const application_number = AppNo;
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/check_ADM_state/archives`,
        {
          application_number,
        },
      )
      .then((response) => {
        Applicant = response.data.data;
        console.log(Applicant);
        if (Applicant?.admissions?.acceptance_of_adm === "accepted") {
          dispatch(DispatchADMhubAuth());
          // if (response.data?.data?.status == 200) {
          redirect(
            `/admission_status/${AppNo}/admitted?email=${Applicant?.email}`,
          );
          // } else {
          //   alert(response.data?.data?.message);
          // }
        } else if (!Applicant) {
          alert("No admission record found for this application number");
        } else {
          dispatch(DispatchADMhubAuth());
          redirect(`/admission_status/${AppNo}`);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }

  const DispatchADMhubAuth = () => async (dispatch) => {
    try {
      dispatch(Action.startAdmissionAction({ Applicant }));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <section className="sectionarchivesAdmHub a1">
      {loading ? <IsLoading /> : null}
      <div className="fx-cl fx-jc fx-ac chckarchivesState space2 fs4">
        <div className="chckarchivesStateDisc fx-cl space2 ">
          <div
            className="fx-cl spacem "
            style={{ width: "100%", fontSize: "1rem" }}
          >
            <div className="fx-ac space1 hubfCont">
              <input
                value={AppNo}
                onChange={(event) => {
                  setAppNo(event.target.value);
                }}
                type="text"
                name="application_number"
                placeholder="Enter application no..."
              />
            </div>
          </div>
          <button onClick={() => getClientStatus()}>
            Check admission from Archives
          </button>
        </div>
      </div>
    </section>
  );
}
